// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"body___yGpZe","container":"container___T9J3J","size":"size___Uji82","header":"header___shboj"};